import { render, staticRenderFns } from "./SelectPassengers.vue?vue&type=template&id=e0eaa24a&"
import script from "./SelectPassengers.vue?vue&type=script&lang=js&"
export * from "./SelectPassengers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0eaa24a')) {
      api.createRecord('e0eaa24a', component.options)
    } else {
      api.reload('e0eaa24a', component.options)
    }
    module.hot.accept("./SelectPassengers.vue?vue&type=template&id=e0eaa24a&", function () {
      api.rerender('e0eaa24a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectPassengers.vue"
export default component.exports